import { carryForwardFromResource } from 'libs.consent.common';
// Re-exported so Studio keeps importing it from here; it lives in common because the bundler reads it too.
export { carryForwardFromResource };
export const DIMENSION_EPSILON_PT = 1;
const pageBoxDiffers = (page, parentSizes, newSizes) => {
    if (!parentSizes || !newSizes) {
        return false;
    }
    const parent = parentSizes.get(page);
    const next = newSizes.get(page);
    if (!parent || !next) {
        return false;
    }
    return (Math.abs(parent.width - next.width) > DIMENSION_EPSILON_PT ||
        Math.abs(parent.height - next.height) > DIMENSION_EPSILON_PT);
};
const isOverflowPage = (page, newPageCount) => page < 1 || page > newPageCount;
const inheritedPlaced = (placed) => placed !== false;
/**
 * Older overlays omit `placed`. Treat missing as placed so Keep does not fail publish on
 * choice options that are already on the page.
 */
export const coerceInheritedPlacements = (elements) => elements.map((element) => {
    const options = element.config.ec__options?.map((option) => ({
        ...option,
        placed: inheritedPlaced(option.placed),
    }));
    return {
        ...element,
        placed: inheritedPlaced(element.placed),
        config: options ? { ...element.config, ec__options: options } : element.config,
    };
});
/**
 * Copies overlay elements onto a replacement PDF: same page number and percent position.
 * Overflow pages become unplaced; a changed page box is flagged for confirmation.
 */
export const carryForwardElements = (elements, newPageCount, parentSizes, newSizes) => elements.map((element) => {
    const overflow = isOverflowPage(element.page, newPageCount);
    const options = element.config.ec__options?.map((option) => ({
        ...option,
        placed: isOverflowPage(option.page, newPageCount) ? false : inheritedPlaced(option.placed),
    }));
    return {
        ...element,
        placed: overflow ? false : true,
        needsDimensionConfirmation: overflow ? false : pageBoxDiffers(element.page, parentSizes, newSizes),
        config: options ? { ...element.config, ec__options: options } : element.config,
    };
});
